import { render } from "./Galery.vue?vue&type=template&id=5f27fbfe"
import script from "./Galery.vue?vue&type=script&lang=js"
export * from "./Galery.vue?vue&type=script&lang=js"

import "./Galery.vue?vue&type=style&index=0&id=5f27fbfe&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__